import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import AddClientForm from "./AddClientForm";

type AddClientModalProps = {
  opened: boolean;
  onClose: () => void;
};

function AddClientModal({ opened, onClose }: AddClientModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Add Client"
        onClose={onClose}
        ariaLabel="Close add client modal"
      />
      <AddClientForm onClose={onClose} />
    </Modal>
  );
}

export default AddClientModal;
